export const EVENTOR = "EVENTOR"
export const DATABASE = "DATABASE"
export const MTRSPOOL = "MTRSPOOL"
export const STARTLIST = "STARTLIST"
export const RESULTLIST = "RESULTLIST"
export const CHECKPOINT = "CHECKPOINT"

export const toggleEventSource = ( source) => {
    let returnVal
    switch (source) {
        case EVENTOR:
            returnVal = DATABASE
            break
        case DATABASE:
            returnVal = MTRSPOOL
            break
        case MTRSPOOL:
            returnVal = EVENTOR
            break
        default:
            returnVal = MTRSPOOL
    }
    return returnVal
}